import { graphql } from 'react-relay';
import { useQuery } from '@atlassian/jira-relay-apollo-migration-utils/src/services/use-query/index.tsx';
import type {
	perDeploymentMetricsRelayQuery$variables,
	perDeploymentMetricsRelayQuery$data,
} from '@atlassian/jira-relay/src/__generated__/perDeploymentMetricsRelayQuery.graphql';
import type { ServiceQueryResultWithFetch } from '@atlassian/jira-software-deployments-service-query-types/src/services/types.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import type { DateRange, Deployment } from '../../common/types';
import { useProjectId } from '../get-project';
import { buildQueryVariables, transformResult } from './utils';

export const usePerDeploymentMetrics = (
	dateRange: DateRange | null,
): ServiceQueryResultWithFetch<Deployment[]> => {
	const cloudId = useCloudId();
	const projectId = useProjectId();
	const variables = dateRange ? buildQueryVariables(cloudId, projectId, dateRange) : null;
	const skip = dateRange === null;

	/* eslint-disable @atlassian/relay/unused-fields */

	const queryResult = useQuery<
		perDeploymentMetricsRelayQuery$variables,
		perDeploymentMetricsRelayQuery$data
	>(
		graphql`
			query perDeploymentMetricsRelayQuery($filter: DevOpsMetricsPerDeploymentMetricsFilter!) {
				devOpsMetrics @required(action: THROW) {
					perDeploymentMetrics(first: 400, filter: $filter) @required(action: THROW) {
						nodes @required(action: THROW) {
							deploymentSize @required(action: THROW)
							deployment @required(action: THROW) {
								id @required(action: THROW)
								issueIds @required(action: THROW)
								displayName @required(action: THROW)
								url @required(action: THROW)
								lastUpdated @required(action: THROW)
								environment @required(action: THROW) {
									displayName @required(action: THROW)
								}
								pipeline @required(action: THROW) {
									url @required(action: THROW)
									displayName @required(action: THROW)
								}
							}
						}
					}
				}
			}
		` /* eslint-enable @atlassian/relay/unused-fields */,
		{
			...(variables === null ? {} : { variables: { ...variables } }),
			// @ts-expect-error - TS2345 - Argument of type '{ errorPolicy: string; skip: boolean; variables?: { filter: DevOpsMetricsPerDeploymentMetricsFilter; } | undefined; }' is not assignable to parameter of type '{ variables?: perDeploymentMetricsRelayQuery$variables | undefined; skip?: boolean | undefined; fetchPolicy?: FetchPolicy | undefined; }'.
			errorPolicy: 'all',
			skip,
		},
	);

	return transformResult(queryResult);
};
